module.exports = __webpack_public_path__ + "img/texture-map-mesh.2f6e17f5.png";